<template>
  <div class="nav-box">
    <ul>
      <li @click="jump('/style1/home',{navIndex:1})" :class="tabIndex === 1?'act':''">公司首页</li>
      <li @click="jump('/style1/info',{navIndex:2})" :class="tabIndex === 2?'act':''">企业文化</li>
      <li @click="jump('/style1/project',{navIndex:3})" :class="tabIndex === 3?'act':''">历史项目</li>
      <li @click="jump('/style1/news',{navIndex:4})" :class="tabIndex === 4?'act':''">新闻公告</li>
      <li @click="jump('/style1/contact',{navIndex:5})" :class="tabIndex === 5?'act':''">联系我们</li>
      <li @click="jump('/style1/expert',{navIndex:6})" :class="tabIndex === 6?'act':''">专家抽取</li>
    </ul>
  </div>
</template>

<script>
import '@/util/common';

export default {
  name: 'Nav',
  computed: {
    tabIndex() {
      return this.$store.state.tabIndex;
    },
  },
};
</script>

<style scoped>

</style>
